<template>
    <th class="w-16 min-w-16">{{ $getStrByLng().HEADER_POINTS_RESULT }}</th>
    <th class="w-16 min-w-16">{{ $getStrByLng().HEADER_TOTAL_POINTS_RESULT }}</th>
</template>
<script setup lang="ts"></script>
